import { PageHero } from "@/components/common";
import { AboutCards } from "@/components/home/AboutCards";
import { NftHero } from "@/components/home/NftHero";
import { Benefits } from "@/components/home/Benefits";
import { useLang } from "@/i18n";

const INTRO = {
  en: "MAGABRAZIL is a cultural memecoin project inspired by Brazilian identity, digital culture and a global community — built on Solana. More than a meme: a Web3 experience connecting collectibles, membership and transparent on-chain operations.",
  pt: "A MAGABRAZIL é um projeto cultural de memecoin inspirado na identidade brasileira, na cultura digital e em uma comunidade global — construído na Solana. Mais que um meme: uma experiência Web3 conectando colecionáveis, membresia e operações on-chain transparentes.",
};

export default function About() {
  const { t, lang } = useLang();
  return (
    <>
      <PageHero eyebrow={t("about.eyebrow")} title={t("about.title")} sub={INTRO[lang]} />
      <AboutCards />
      <NftHero />
      <Benefits />
    </>
  );
}
